import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from '@tecalisdev/infinity';
import { LanguageService } from 'src/app/core/services/language.service';
import { IDocumentsDocs, LocalizedText } from 'src/app/user-identification/models/user-identification';
@Component({
	selector: 'app-modal-instructions',
	imports: [TranslatePipe, ModalComponent],
	templateUrl: './modal-instructions.component.html',
})
export class ModalInstructionsComponent implements OnChanges {
	@Input() isVisible: boolean = false;
	@Input() doc: IDocumentsDocs;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	// Lista de tipos de documento que tienen imagen de instrucciones por defecto
	private readonly TYPES_WITH_DEFAULT_IMAGE = [
		'dni',
		'nie',
		'passport',
		'cert_reg_ciu_ue',
		'drive_license',
		'irpf',
		'payroll',
		'worklife',
		'invoice',
		'scripture',
		'check',
	];

	// Cache de las propiedades calculadas para evitar múltiples llamadas
	public instructionsPhotoUrl: string | null = null;

	constructor(private languageService: LanguageService) {}

	ngOnChanges(changes: SimpleChanges): void {
		// Recalcular cuando cambia el documento o su visibilidad
		if (changes['doc'] || changes['isVisible']) {
			this.instructionsPhotoUrl = this.calculateInstructionsPhoto();
		}
	}

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}

	/**
	 * Calcula la ruta de la imagen de instrucciones para mostrar en el modal.
	 * Si el documento no tiene imagen personalizada, retorna la imagen por defecto solo si existe.
	 *
	 * @returns La ruta de la imagen o null si no existe.
	 */
	private calculateInstructionsPhoto(): string | null {
		// Si ya tiene imagen de instrucciones personalizada, retornarla
		const customPhoto = this.resolveText(this.doc?.instructions_photo);
		if (customPhoto) return customPhoto;

		// Solo retornar imagen por defecto si el tipo está en la lista de tipos con imagen
		if (this.doc?.type) {
			const typeLower = this.doc.type.toLowerCase();
			if (this.TYPES_WITH_DEFAULT_IMAGE.includes(typeLower)) {
				return `assets/images/instructions-${typeLower}.png`;
			}
		}

		return null;
	}

	public getTitle(): string {
		return this.resolveText(this.doc?.title) || `DOCUMENTS.TYPES.${this.doc?.type}`;
	}

	public getInstructions(): string {
		return this.resolveText(this.doc?.instructions);
	}

	private resolveText(value?: LocalizedText | null): string {
		return this.languageService.resolveLocalizedText(value);
	}
}
